"use client";

const TestimonialSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">

        {/* Section Title */}
        <h2 className="text-3xl md:text-4xl font-bold text-[#741112] text-center mb-4">
          Voices of Our Trusted Partners
        </h2>
        <p className="text-center text-gray-600 max-w-2xl mx-auto mb-12">
          What Our Partners Say About Working With Us
        </p>

        {/* Centered Video */}
        <div className="flex flex-col items-center">
          <div className="w-full md:w-2/3 lg:w-1/2">
            <div className="relative pb-[56.25%] h-0 rounded-lg overflow-hidden shadow-lg mb-6">
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/ouQKVF6Nvvc?si=Fm4LEYZ42NBls7MQ"
                title="Partner Testimonial"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          {/* Button below video */}
          <a
            href="https://www.youtube.com/@realation6580"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#741112] hover:bg-[#5e0e0e] text-white font-semibold py-3 px-8 rounded-full transition"
          >
            Watch More Videos
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
